import { Children } from 'react';

import { IntlProvider } from 'react-intl';
import { connect } from 'react-redux';

import de from './de.json';
import en from './en.json';
import ToggleLocale from './ToggleLocale';

const messages = {
    en,
    de
};

const mapStateToProps = ({ intl }) => ({
    ...intl
});

const mapDispathToProps = () => ({});

const IwIntlProvider = (props) => {
    const { ready, children, locale, language } = props;

    // Provide fallback IntlProvider context when not ready to prevent
    // "Could not find required `intl` object" errors
    const fallbackLocale = 'en-GB';
    const fallbackLanguage = 'en';

    const effectiveLocale = ready ? locale : fallbackLocale;
    const effectiveLanguage = ready ? language : fallbackLanguage;

    return (
        <>
            <IntlProvider
                locale={effectiveLocale}
                messages={messages[effectiveLanguage]}
            >
                {Children.only(children)}
            </IntlProvider>
            <ToggleLocale />
        </>
    );
};

// eslint-disable-next-line import/no-default-export
export default connect(mapStateToProps, mapDispathToProps)(IwIntlProvider);
